/**
 * A secure tab opener function, which prevents malicious actors from executing "tabnapping" attacks when having access to the window.opener object
 * More information about this can be found in the below list of links:
 *
 * https://sites.google.com/site/bughunteruniversity/nonvuln/phishing-with-window-opener
 * https://medium.com/@jitbit/target-blank-the-most-underestimated-vulnerability-ever-96e328301f4c
 * */
const secureTabOpener = (url) => {
    const newTab = window.open(url, '_blank', 'noopener,noreferrer');
    if (newTab) {
        newTab.opener = null;
    }
};
export default secureTabOpener;
